import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'cass-display-placement',
	templateUrl: './display-placement.component.html',
	styleUrls: ['./display-placement.component.css']
})
export class DisplayPlacementComponent implements OnInit {

	constructor() { }

	@Input()
	get placementLabel(): string | undefined {
		return this._placementLabel;
	}
	set placementLabel(placementLabel: string | undefined) {
		this._placementLabel = placementLabel;
	}
	private _placementLabel: string | undefined;

	ngOnInit(): void {
	}
}
